import { computed } from 'vue';

export function useAnchoMinimoMM(elementRef) {
  const anchoMinimoMM = computed(() => {
    const m = elementRef.value ?? {};
    const lateralesMM = Number(m.Laterales ?? 0);
    const medidaEjeMM = Number(m.MedidaEje ?? 0);
    const gapEjeMM = Number(m.GapEje ?? 0);
    const etiquetasEje = Math.max(0, Math.floor(Number(m.EtiquetasEje ?? 0)));

    const cantidadGaps = etiquetasEje > 0 ? etiquetasEje - 1 : 0;

    const ancho = medidaEjeMM * etiquetasEje + lateralesMM * 2 + gapEjeMM * cantidadGaps;

    return ancho;
  });

  return { anchoMinimoMM };
}
